export const NextPaths = {
  // Shared routes
  home: '/provider/home',

  // Dashboard Provider/Admin Auth (for SolvaPay users)
  login: '/login',
  signup: '/sign-up',
  emailVerification: '/verify-email',
  acceptInvitation: '/accept-invitation',

  // OAuth Customer Auth (for provider's customers)
  oauthLogin: '/auth/login',
  oauthForgotPassword: '/auth/forgot-password',
  oauthResetPassword: '/auth/reset-password',
  oauthCallback: '/auth/callback',
  oauthCustomerConsent: '/auth/customer/consent',

  // Success page (shared by both flows)
  success: '/success',

  // Provider routes
  providerRegister: '/provider/register',
  providerOnboardingProduct: '/provider/onboarding/product',
  providerOnboardingProductSdk: '/provider/onboarding/product/sdk',
  providerHome: '/provider/home',
  providerDashboard: '/provider/dashboard',
  providerProfile: '/provider/profile',
  providerAccount: '/provider/account',
  providerSettings: '/provider/settings',
  providerSettingsGeneral: '/provider/settings?tab=general',
  providerSettingsBusinessEdit: '/provider/settings?tab=business&editBusiness=1',

  // Product routes
  providerProducts: '/provider/products',
  providerCreateProduct: '/provider/products/create',
  providerProductDetail: (id: string) => `/provider/products/${id}`,
  providerEditProduct: (id: string) => `/provider/products/${id}/edit`,
  providerProductPlans: (id: string) => `/provider/products/${id}/plans`,
  providerProductPurchases: (id: string) => `/provider/products/${id}/purchases`,
  providerProductTransactions: (id: string) => `/provider/products/${id}/transactions`,
  providerProductCustomers: (id: string) => `/provider/products/${id}/customers`,
  providerProductUsage: (id: string) => `/provider/products/${id}/usage`,
  providerProductMcpConfig: (id: string) => `/provider/products/${id}?tab=mcpConfig`,
  providerProductToolsAccess: (id: string) => `/provider/products/${id}/tools-access`,

  providerFinancials: '/provider/financials',
  providerTransactions: '/provider/transactions',
  providerPurchases: '/provider/purchases',

  // Customer routes
  providerCustomers: '/provider/customers',
  providerCreateCustomer: '/provider/customers/create',
  providerEditCustomer: (id: string) => `/provider/customers/${id}/edit`,
  providerCustomerDetail: (id: string) => `/provider/customers/${id}`,

  // Usage routes
  providerUsage: '/provider/usage',

  // Notification routes
  providerNotifications: '/provider/notifications',

  // SDK routes
  providerDevelopers: '/provider/developers',
  providerEditSecretKey: (id: string) => `/provider/developers/keys/edit/${id}`,

  // Stripe OAuth routes
  stripeOAuthCallback: '/stripe/oauth/callback',

  // Admin routes
  adminHome: '/admin/home',
  adminProviders: '/admin/providers',
  adminTransactions: '/admin/transactions',
  adminProducts: '/admin/products',
  adminUsers: '/admin/users',
  adminAccount: '/admin/account',

  // Super Admin routes
  superAdminLogin: '/operation/login',
  superAdminDashboard: '/operation/dashboard',
  superAdminProviders: '/operation/providers',
  superAdminProviderDetail: (id: string) => `/operation/providers/${id}`,
  superAdminUsers: '/operation/users',
  superAdminUserDetail: (id: string) => `/operation/users/${id}`,
  superAdminCustomers: '/operation/customers',
  superAdminCustomerDetail: (id: string) => `/operation/customers/${id}`,
  superAdminProductDetail: (id: string) => `/operation/products/${id}`,
  superAdminPurchaseDetail: (id: string) => `/operation/purchases/${id}`,
  superAdminMeterDetail: (id: string) => `/operation/meters/${id}`,
  superAdminTransactions: '/operation/transactions',
  superAdminTransactionDetail: (id: string) => `/operation/transactions/${id}`,
  superAdminEvents: '/operation/events',
  superAdminUsage: '/operation/usage',
  superAdminPreregistrations: '/operation/preregistrations',
  superAdminPreregistrationDetail: (id: string) => `/operation/preregistrations/${id}`,
  superAdminAuditLog: '/operation/audit-log',
  superAdminFeatureFlags: '/operation/feature-flags',
  superAdminAccount: '/operation/account',

  // Customer routes (public pages)
  customerCheckout: '/customer/checkout',
}
